import NavigationSection from "../navigation-section";
import {LayoutMenuState} from "../../../../layout/layout/const";


// const debug = "navigationStructureOnClick"
const debug = false

export async function navigationStructureOnClick(section:NavigationSection) {

    debug && console.log(debug, "navigationStructureOnClick() section=", section);

    await gd.layout.navigation.openSectionV2(section)

    switch (gd.layout.menuState) {

        case LayoutMenuState.STATIC                 :
            if (section.defaultAppUrl) {
                gd.navigation.goTo(section.defaultAppUrl, true)
            }
            break
    }

    return true
}
